module.exports = __webpack_public_path__ + "img/Tela docxassinatura.c027ca07.jpg";